function getBgColorForTab<T>(tabValue: T, listingTabs: T[]) {
  return listingTabs.includes(tabValue)
    ? 'background.list'
    : 'background.other';
}

export default getBgColorForTab;
